module.exports = __webpack_public_path__ + "img/close.33bf467c.svg";